// TÉMOIGNAGES DE DÉMONSTRATION — fictifs, uniquement pour la maquette.
// À remplacer par des témoignages réels avant le lancement, puis passer isDemo à false.
// avatar : laisser "" pour afficher les initiales, ou coller l'URL d'une photo autorisée.
export const testimonialsIsDemo = true;

export const testimonials = [
  {
    name: "Émilie Laurent",
    description: "Maman de deux enfants",
    avatar: "",
    paragraphs: [
      "Je voulais tellement transmettre ma foi à mes enfants, mais entre l’école, les écrans et le quotidien, je ne savais jamais comment m’y prendre.",
      "Avec ces paraboles illustrées, nous avons enfin trouvé une manière simple et douce de parler de Jésus ensemble.",
      "Le plus beau, c’est de voir mes enfants s’intéresser à la Parole de Dieu et me poser des questions d’eux-mêmes. C’est exactement ce que je recherchais.",
    ],
  },
  {
    name: "Nadia Benali",
    description: "Maman d’une petite fille",
    avatar: "",
    paragraphs: [
      "J’ai toujours voulu faire découvrir la Bible à ma fille, mais certains passages me semblaient trop compliqués à expliquer à son âge.",
      "Les illustrations captent son attention et les histoires nous permettent d’aborder naturellement l’amour, le pardon et la bonté.",
      "Je n’ai plus besoin de chercher pendant des heures comment lui parler de Dieu. Nous ouvrons une histoire, nous lisons ensemble et la conversation vient toute seule.",
    ],
  },
  {
    name: "Camille Moreau",
    description: "Maman de deux enfants",
    avatar: "",
    paragraphs: [
      "Je cherchais une alternative aux écrans qui ne soit pas juste une occupation de plus, mais un vrai moment à partager avec mes enfants.",
      "Maintenant, nous choisissons une parabole, nous nous installons ensemble et nous prenons quelques minutes pour lire et discuter.",
      "Ce que j’aime le plus, c’est que ces petits moments nous rapprochent tout en transmettant les valeurs chrétiennes qui me tiennent tant à cœur.",
    ],
  },
  {
    name: "Françoise Dubois",
    description: "Grand-mère de trois petits-enfants",
    avatar: "",
    paragraphs: [
      "En tant que grand-mère, ce qui me tient le plus à cœur, c’est que mes petits-enfants grandissent en connaissant l’amour de Jésus.",
      "Je voulais leur offrir bien plus que des jouets : des souvenirs précieux et des enseignements qu’ils pourront garder dans leur cœur.",
      "Ces histoires illustrées me donnent une belle occasion de partager ma foi avec eux. Les voir écouter avec autant de curiosité est un vrai bonheur.",
    ],
  },
  {
    name: "Sophie Bernard",
    description: "Maman passionnée par l’éducation chrétienne",
    avatar: "",
    paragraphs: [
      "J’en avais assez de chercher des ressources chrétiennes pour enfants un peu partout, sans jamais trouver quelque chose de vraiment complet et adapté à leur âge.",
      "Plus de 50 paraboles illustrées, avec des activités à imprimer… Je ne pensais pas trouver autant de ressources réunies dans un seul pack à ce prix-là !",
      "Pour moi, c’est une petite bibliothèque chrétienne à la maison. Nous pouvons y revenir régulièrement, et les enfants ont toujours quelque chose à découvrir.",
    ],
  },
];
